// Datadog RUM helper functions

// PII Masking utilities
const maskEmail = (email) => {
  if (!email) return '';
  const [username, domain] = email.split('@');
  if (!username || !domain) return email;
  
  const maskedUsername = username.length > 2 
    ? username[0] + '*'.repeat(username.length - 2) + username[username.length - 1]
    : '*'.repeat(username.length);
  
  return `${maskedUsername}@${domain}`;
};

const maskPhone = (phone) => {
  if (!phone) return '';
  const phoneStr = phone.toString();
  return phoneStr.length > 4 
    ? phoneStr.slice(0, 4) + '*'.repeat(phoneStr.length - 5) + phoneStr.slice(-1)
    : '*'.repeat(phoneStr.length);
};

const maskPAN = (pan) => {
  if (!pan) return '';
  return pan.length > 4 
    ? '*'.repeat(pan.length - 4) + pan.slice(-4)
    : '*'.repeat(pan.length);
};

const maskName = (name) => {
  if (!name) return '';
  return name.length > 2 
    ? name[0] + '*'.repeat(name.length - 2) + name[name.length - 1]
    : '*'.repeat(name.length);
};

const createMaskedUserData = (userData) => {
  return {
    ucid: userData.client_UCID,
    name: maskName(userData.clientName),
    email: userData.maskedEmail || maskEmail(userData.email),
    mobileNumber: userData.maskedContact || maskPhone(userData.mobile),
    pan: maskPAN(userData.paN_NO),
    clientType: userData.clientType,
    isNRI: userData.nriFlag === 'True',
    hasMPin: userData.mPinFlag === 'true',
    isIndividualPan: userData.isIndividualPan,
    hasActiveEMandate: userData.isHaveActiveEMandate,
    isPMSCodeMerger: userData.isPMSCodeMerger
  };
};

export const initDatadog = () => {
  if (typeof window !== 'undefined' && typeof document !== 'undefined' && window.DD_RUM) {
    window.DD_RUM.init({
      beforeSend: (event, context) => {
        // discard a RUM error if its message includes 'csp_violation'
        if (event.type === 'error' && event.error.message.includes('csp_violation')) {
          return false
        }
      },
      clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
      applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID,
      site: process.env.REACT_APP_DATADOG_SITE || 'datadoghq.com',
      service: process.env.REACT_APP_DATADOG_SERVICE || 'amc-website-uat',
      env: process.env.REACT_APP_DATADOG_ENV || 'uat',
      sessionSampleRate: parseInt(process.env.REACT_APP_DATADOG_SESSION_SAMPLE_RATE) || 100,
      sessionReplaySampleRate: parseInt(process.env.REACT_APP_DATADOG_SESSION_REPLAY_SAMPLE_RATE) || 20,
      trackBfcacheViews: true,
      defaultPrivacyLevel: 'mask-user-input',
    });
  }
};

export const clearDatadogUser = () => {
  if (typeof window !== 'undefined' && typeof document !== 'undefined' && window.DD_RUM) {
    window.DD_RUM.clearUser();
  }
};

export const setDatadogUserSafe = (userData) => {
  if (typeof window !== 'undefined' && typeof document !== 'undefined' && window.DD_RUM) {
    const maskedData = createMaskedUserData(userData);
    window.DD_RUM.setUser(maskedData);
  }
};

export const addDatadogAction = (name, context = {}) => {
  if (typeof window !== 'undefined' && typeof document !== 'undefined' && window.DD_RUM) {
    window.DD_RUM.addAction(name, context);
  }
};

export const addDatadogError = (error, context = {}) => {
  if (typeof window !== 'undefined' && typeof document !== 'undefined' && window.DD_RUM) {
    window.DD_RUM.addError(error, context);
  }
};